import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
interface isActiveProps {
  isActive: boolean;
}

type Props = isActiveProps & {
  onClick: Function;
  text: string;
};

const HashTagButton = ({ ...props }: Props) => {
  return (
    <Styled
      onClick={() => {
        props.onClick();
      }}
      isActive={props.isActive}
    >
      <span>{props.text}</span>
    </Styled>
  );
};

type StyledProps = isActiveProps;

export const Styled = styled.div<StyledProps>`
  display: inline-block;
  position: relative;
  padding: 7px 12px;
  border-radius: 16px;
  background-color: ${({ isActive }) => {
    return isActive ? StyleConfig.COLOR.PRIMARY : '#fff';
  }};
  text-align: center;
  font-size: 0;

  > span {
    font-size: 12px;
    font-weight: bold;
    color: ${({ isActive }) => {
      return isActive ? '#fff' : StyleConfig.COLOR.PRIMARY;
    }};
    display: inline-block;
  }
`;
export default HashTagButton;
